import { getCustomerPreviewValues } from "@utils";

export const SMS_SOFT_LIMIT = 480;
export const SMS_HARD_LIMIT = 700;

export function buildTokenReplacer(previewTokens) {
  const tokenMap = previewTokens
    ? Object.fromEntries(previewTokens.map((t) => [`{${t.token}}`, t.value]))
    : Object.fromEntries(getCustomerPreviewValues().map((t) => [`{${t.token}}`, t.value]));
  return (text) => {
    if (!text) return "";
    return text.replace(/\{[^\s{}]+\}/g, (match) => tokenMap[match] ?? match);
  };
}

export function extractFormValues(template) {
  const emailMsg = template?.messages?.find(
    (m) => m.communicationMethod === "Email",
  );
  const smsMsg = template?.messages?.find(
    (m) => m.communicationMethod === "Sms",
  );

  return {
    name: template?.name ?? "",
    invoicesRequested: template?.invoicesRequested ?? "Custom",
    mandatory: template?.paymentRequirement === "Mandatory",
    attachPdfStatement: template?.attachPdfStatement ?? false,
    emailSubject: emailMsg?.content?.subject ?? "",
    emailTitle: emailMsg?.content?.title ?? "",
    emailMainText: emailMsg?.content?.mainText ?? "",
    emailActionTitle: emailMsg?.content?.actionArea?.title ?? "",
    emailButtonText:
      emailMsg?.content?.actionArea?.buttonText ?? "Review and pay",
    amountDisplay: "{amount_requested}",
    smsText: smsMsg?.content?.text ?? "",
    allowCardPayment: template?.allowCardPayment ?? false,
    paymentProfileId: template?.paymentProfileId ?? null,
  };
}
